import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { addCategoryApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const addCategory = createAsyncThunk('addCategory', async (payload) => {
  return await addCategoryApi(payload);
});

const addCategorySlice = createSlice({
  name: 'addCategory', // Unique Name
  initialState,
  reducers: {
    addCategoryReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCategory.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(addCategory.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(addCategory.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { addCategoryReset } = addCategorySlice.actions;

export default addCategorySlice.reducer;
